import { useContext } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { UserContext } from 'contexts/user';

const PrivateRoute = ({
  component: Component,
  onSignIn,
  onCountUpdate,
  onMessages,
  ...rest
}) => {
  const { user } = useContext(UserContext);

  return (
    <Route
      {...rest}
      render={(props) => {
        return user ? (
          <Component
            {...props}
            onSignIn={onSignIn}
            onCountUpdate={onCountUpdate}
            onMessages={onMessages}
          />
        ) : (
          <Redirect to="/signin" />
        );
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  onSignIn: PropTypes.func.isRequired,
  onCountUpdate: PropTypes.func,
  onMessages: PropTypes.func,
};

export default withRouter(PrivateRoute);
